import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import WorkStartupCompanion from './WorkStartupCompanion';

export default function RemoteWorkLaunchPreview({ launch }) {
  const { colors } = useTheme();
  return <ScrollView style={styles.scroll} contentContainerStyle={styles.content}>
    <View style={styles.column}>
      {!!launch.projectName && <View style={styles.project}>
        <Icon name="laptop" size={16} color={colors.text_color_secondary} />
        <Text size="m" color="secondary" style={styles.rowText}>{launch.projectName}</Text>
      </View>}
      <View style={[styles.message, { backgroundColor: colors.solid_color_secondary }]}>
        <Text size="l" style={styles.prompt}>{launch.prompt}</Text>
        {launch.fileCount > 0 && <Text size="s" color="secondary" style={{ marginTop: 8 }}>
          {launch.fileCount} {launch.fileCount === 1 ? 'attachment' : 'attachments'}
        </Text>}
      </View>
      <View style={styles.status}>
        <WorkStartupCompanion phase={launch.phase} startedAt={launch.startedAt} />
      </View>
      {!!launch.projectName && <View style={styles.hint}>
        <Text size="s" color="secondary" style={styles.hintText}>Keep Gab AI open on your Mac.</Text>
        <Text size="s" color="secondary" style={styles.hintText}>Your chat will open automatically.</Text>
      </View>}
    </View>
  </ScrollView>;
}

const styles = StyleSheet.create({
  // Home centers its children; explicitly fill its width instead of measuring
  // the ScrollView from an unwrapped message or status line.
  scroll: { flex: 1, width: '100%', minWidth: 0, alignSelf: 'stretch' },
  content: { flexGrow: 1, padding: 20 },
  column: { width: '100%', maxWidth: 720, minWidth: 0, alignSelf: 'center' },
  project: { flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 24 },
  message: { alignSelf: 'flex-end', maxWidth: '92%', borderRadius: 22, paddingHorizontal: 18, paddingVertical: 14 },
  prompt: { flexShrink: 1, lineHeight: 25 },
  rowText: { flex: 1, minWidth: 0 },
  hint: { gap: 4 },
  hintText: { lineHeight: 20 },
  status: { marginTop: 20, marginBottom: 10 },
});
